<template>
  <v-container fluid>
    <v-card-actions>
      <v-btn-toggle
        v-model="toggle" 
        mandatory
        group
        color="primary"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn 
              text 
              icon
              v-on="on"
              @click="showActiveJobGroups = 1"
            >
              <v-icon>select_all</v-icon>
            </v-btn>
          </template>
          <span>Active Job Groups</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn 
              text
              icon 
              v-on="on"
              @click="showActiveJobGroups = 0"
            >
              <v-icon>delete_outline</v-icon>
            </v-btn>
          </template>
          <span>Trash</span>
        </v-tooltip>
      </v-btn-toggle>
      <v-divider
        class="mr-5"
        vertical
      />
      <div v-show="showActiveJobGroups">
        <setup-job-groups-dialog-create
          v-if="$hasPermissionTo(['create job groups'])"
          @created="loadData"
        />
      </div>
    </v-card-actions>

    <v-row>
      <v-col
        v-for="jobGroup in filteredJobGroups"
        :key="jobGroup.id"
        cols="12"
        md="4"
        xl="4"
      >
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="[`elevation-${hover ? 12 : 2}`, 'pa-1']"
          >
            <v-list one-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-capitalize px-0">
                    {{ jobGroup.name }}
                  </v-list-item-title>

                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12">
                          <span class="font-weight-bold">Leave Entitlements:</span>
                        </v-col>
                      </v-row>

                      <span v-if="jobGroup.job_group_leave_entitlement_settings.length>0">
                        <v-chip
                          v-for="leave_entitlement_setting in jobGroup.job_group_leave_entitlement_settings"
                          :key="leave_entitlement_setting.id"
                          dense
                          class="text--primary mx-1"
                        >
                          {{ leave_entitlement_setting.leave_entitlement_setting.name }}
                        </v-chip>
                      </span>
                      <span v-else>
                        No Data Available
                      </span>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider light />
            <v-card-actions v-if="showActiveJobGroups">
              <v-spacer />
              <setup-job-groups-dialog-edit
                v-if="$hasPermissionTo(['update job groups'])"
                :job-group="jobGroup"
                @updated="loadData"
              />
              <setup-job-groups-dialog-delete
                v-if="$hasPermissionTo(['delete job groups'])"
                :job-group="jobGroup"
                @deleted="loadData"
              /> 
            </v-card-actions>
            <v-card-actions v-else>
              <v-spacer />
              <setup-job-groups-dialog-restore
                v-if="$hasPermissionTo(['delete job groups'])"
                :job-group="jobGroup"
                @restored="loadData"
              />
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row> 

    <v-row
      v-show="jobGroups.length === 0 && loading === false"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <div class="headline">
          <span class="blue-grey--text">No Data Available</span>
        </div>
      </v-col>   
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupJobGroupsDialogCreate: () => import('@/components/setup/job/groups/DialogCreate'),
      SetupJobGroupsDialogEdit: () => import('@/components/setup/job/groups/DialogEdit'),
      SetupJobGroupsDialogDelete: () => import('@/components/setup/job/groups/DialogDelete'),
      SetupJobGroupsDialogRestore: () => import('@/components/setup/job/groups/DialogRestore'),
    },

    data () {
      return {
        loading: true,
        showActiveJobGroups: 1,
        toggle: 0,
        jobGroups: [],
        trashedJobGroups: [],
      }
    },

    computed: {
      filteredJobGroups () {
        return this.showActiveJobGroups ? this.jobGroups : this.trashedJobGroups
      },
    },

    watch: {
      showActiveJobGroups: {
        immediate: true,
        handler (value) {
          this.loadData()
        },
      },
    },

    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        Promise.all([
          this.$api.jobGroups().list(),
          this.$api.jobGroups().listTrashed(),
        ]).then(([jobGroups, trashedJobGroups]) => {
          this.jobGroups = jobGroups.data
          this.trashedJobGroups = trashedJobGroups.data

          this.loading = false
        })
      },
    },
  }
</script>
